import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React from 'react';
import {Platform, View} from 'react-native';
import {connect} from 'react-redux';
import {IData} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {StackParams} from '../../../../../data/types/navigation';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../../components/Header/HeaderScreen';
import {ProduitItem} from '../../../../components/ProduitItem';
import globalStyle from '../../../../styles/globalStyle';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<StackParams>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function SouscriptionMenuScreen(props: any) {
  const categorieId = props?.route?.params?.id;

  const {navigate} = useNavigation<NavigationProps>();

  const datas: IData[] = [
    {
      libelle: 'Souscrire',
      destinationPage: 'DemanderDevisAssuranceVoyage',
      navigate: () => {
        navigate('DemanderDevisAssuranceVoyage', {
          category: '',
          destination: '',
          listNaissance: [],
          dateDebut: '',
          dateFin: '',
          motif: '',
        });
      },
      id: 'souscrire_001',
      data: categorieId,
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      imageUrl: require('../../../../../ressources/images/image_ph.png'),
      montant: '',
      headerTitle: 'Demander simulation',
    },
    {
      libelle: "Liste d'attente souscription",
      destinationPage: 'ListDevisAssuranceVoyage',
      navigate: () => {
        navigate('ListDevisAssuranceVoyage');
      },
      id: 'listeDAttente_001',
      data: categorieId,
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      imageUrl: require('../../../../../ressources/images/image_ph.png'),
      montant: '',
      headerTitle: 'Demander simulation',
    },
  ];

  const containerStyle =
    Platform.OS === 'web' ? globalStyle.containerFluid : styles.ListContainer;

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title={props?.route?.params?.headerTitle}
        type="retour"
        noBreadcrumb={false}
      />
      <View style={containerStyle}>
        <ProduitItem data={{items: datas}} />
      </View>
    </View>
  );
}
export const SouscriptionMenuVoyage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SouscriptionMenuScreen);
